/* @flow */
import { Set, Map, List, Record, OrderedMap } from 'immutable';
import type { IndicatorTag } from 'modules/tags/types';

export const getDaysBack = (days: number): number => Date.now() - (1000 * 60 * 60 * 24 * days);

export type LibraryFetchParams = Record<{
  page: number,
  startPage: number,
  to: number,
  from: number,
  hasNext: boolean,
  pageSize: number,
  tags: List<Map<any, any>>,
  excludedTags: List<Map<any, any>>,
  enclaveFilters: List<string>,
}>;

export const DefaultFetchParams = Record({
  page: 1,
  startPage: 1,
  to: Date.now(),
  from: getDaysBack(7),
  hasNext: false,
  pageSize: 50,
  tags: List(),
  excludedTags: List(),
  enclaveFilters: Set(),
});

export type IndicatorLibrary = Record<{
  loading: boolean,
  error: boolean,
  indicatorList: OrderedMap<string, any>,
  fetchParams: LibraryFetchParams,
  currentDisplayRange: string,
  currentResultRange: Map<string, number>,
}>;

export const defaultRange = 'Past 7 days';

export const DefaultLibrary = Record({
  loading: false,
  error: false,
  indicatorList: OrderedMap(), // IOC list results
  fetchParams: DefaultFetchParams(), // The current fetch params, including from, to, enclave, & tags
  currentDisplayRange: defaultRange, // The current list range, displayed in readable English
  currentResultRange: Map({ // The current result range, used for paginating results
    from: null,
    to: null,
  }),
});

export type IndicatorEnrichment = Record<{
  loading: boolean,
  error: boolean,
  data: OrderedMap<any, any>,
}>;

export const DefaultEnrichment = Record({
  loading: false,
  error: false,
  data: Map(),
});

export type IndicatorMetadata = Record<{
  loading: boolean,
  indicatorType: string,
  value: string,
  lastSeen: number,
  sightings: number,
  correlationCount: number,
  noteCount: number,
  tags: List<IndicatorTag>,
  enclaves: Set<string>,
  priorityLevel?: string,
}>;

export const DefaultIndicatorMetadata = Record({
  loading: false,
  indicatorType: '',
  value: '',
  lastSeen: 0,
  sightings: 0,
  correlationCount: 0,
  noteCount: 0,
  tags: List(),
  enclaves: Set(),
  priorityLevel: 'LOW',
});

export type TagCollection = Record<{
  loading: boolean,
  indicators: List<IndicatorTag>,
}>;

export const DefaultTagCollection = Record({
  loading: false,
  indicators: List(),
});



// WEBPACK FOOTER //
// ./src/app/modules/indicators/types.js